import Grid from "@mui/material/Grid2";
import WhyETech from "../../assets/images/etl-page/WhyETech.png";
import React from "react";
import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const PREFIX = "WhyEtechSection";

const classes = {
  smsContainer: `${PREFIX}-smsContainer`,
  smsData: `${PREFIX}-smsData`,
  smsImage: `${PREFIX}-smsImage`,
  smsHeading: `${PREFIX}-smsHeading`,
  smsContent: `${PREFIX}-smsContent`,
  smsPoints: `${PREFIX}-smsPoints`,
  smsPointItem: `${PREFIX}-smsPointItem`,
};

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`& .${classes.smsContainer}`]: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    marginTop: "1rem",
    padding: "1%",
    marginBottom: "1rem",
    [theme.breakpoints.up("md")]: {
      flexDirection: "row",
      textAlign: "left",
    },
  },
  [`& .${classes.smsData}`]: {
    padding: "3%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    marginTop: "1rem",
    marginBottom: "1rem",
    [theme.breakpoints.up("md")]: {
      alignItems: "flex-start",
      textAlign: "left",
    },
  },
  [`& .${classes.smsImage}`]: {
    display: "flex",
    flexDirection: "column",
    alignItem: "center",
    justifyContent: "center",
  },
  [`& .${classes.smsHeading}`]: {
    padding: "2em 1em 0em 0em",
    textAlign: "left",
    letterSpacing: "0.66px",
    color: "#223140",
    width: "90%",
    fontSize: 32,
    fontFamily: "AvenirLTStd-Book",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      padding: 0,
      marginTop: "1em",
      fontSize: 25,
    },
    [theme.breakpoints.between("sm", "md")]: {
      padding: "2em 1em 1em 0em",
      fontSize: 25,
    },
    [theme.breakpoints.up("md")]: {
      textAlign: "left",
      fontSize: 25,
    },
    [theme.breakpoints.up("md")]: {},
  },
  [`& .${classes.smsContent}`]: {
    padding: "2em 1em 1em 0em",
    fontSize: 20,
    fontWeight: 100,
    width: "90%",
    color: "#223140",
    LineHeight: "100%",
    fontFamily: "AvenirLTStd-Book",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      padding: 0,
      textAlign: "left",
      marginTop: "1em",
      fontSize: 16,
    },
    [theme.breakpoints.between("sm", "md")]: {
      padding: "2em 1em 1em 0em",
      fontSize: 25,
      width: "80%",
      textAlign: "left",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: 25,
      textAlign: "left",
    },
    [theme.breakpoints.up("md")]: {},
  },
  [`& .${classes.smsPoints}`]: {
    listStyleType: "none",
    padding: 0,
  },
  [`& .${classes.smsPointItem}`]: {
    display: "flex",
    alignItems: "center",
    marginBottom: "0.5em",
    fontSize: 20,
    fontWeight: 100,
    color: "#223140",
    fontFamily: "AvenirLTStd-Book",
    [theme.breakpoints.down("sm")]: {
      fontSize: 16,
      textAlign: "left",
    },
    [theme.breakpoints.between("sm", "md")]: {
      fontSize: 20,
      textAlign: "left",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: 20,
    },
    "& svg": {
      color: "#c20d0b",
      marginRight: "0.5em",
      fontSize: "20px",
    },
  },
}));

function WhyEtech() {
  return (
    <StyledGrid container className={classes.smsContainer}>
      <Grid item size={{ sm: 12, md: 5, xs: 12 }} className={classes.smsImage}>
        <img src={WhyETech} alt="Why ETL Tech" />
      </Grid>
      <Grid item size={{ sm: 12, md: 7, xs: 12 }} className={classes.smsData}>
        <Typography className={classes.smsHeading}>
          Why the need for an{" "}
          <span style={{ color: "#c20d0b" }}>eTechlog?</span>
        </Typography>
        <Typography className={classes.smsContent}>
          We have been developing our application over the past 4 years and in
          that time we’ve spoken with 100's of operators. The same issues come
          up repeatedly in operations using paper processes.{" "}
        </Typography>
        <ul className={classes.smsPoints}>
          <li className={classes.smsPointItem}>
            <ArrowForwardIcon />
            No updated view of fleet maintenance status
          </li>
          <li className={classes.smsPointItem}>
            <ArrowForwardIcon />
            Lack of data for effective forecasting & planning
          </li>
          <li className={classes.smsPointItem}>
            <ArrowForwardIcon />
            Repetitive, time intensive data entry that is prone to error
          </li>
          <li className={classes.smsPointItem}>
            <ArrowForwardIcon />
            Lack of data visibility & delays in passing info around the
            operation
          </li>
          <li className={classes.smsPointItem}>
            <ArrowForwardIcon />
            No data analysis makes it difficult to optimise maintenance
            scheduling
          </li>
          <li className={classes.smsPointItem}>
            <ArrowForwardIcon />
            Errors & missing logs cause issues with handovers, audits &
            authorities
          </li>
        </ul>
      </Grid>
    </StyledGrid>
  );
}

export default WhyEtech;
